var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-view',{attrs:{"value":_vm.value,"title":_vm.title,"modal":_vm.modal,"scrollable":false},on:{"input":_vm.$listeners.input}},[_c('select-user-tags-controller',{on:{"save":_vm.$listeners.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }